var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _setup.tid } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Configure dataset")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-link btn-sm",
              attrs: {
                href: `/#/admin/integrations/pipelines/details/${_setup.tid}/${_setup.id}`,
                type: "button",
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-arrow-left",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Back")]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-5 col-sm-6 text-right" }),
      ]),
    ]),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            on: { click: _setup.handleCreateDatasetCommandV1 },
          },
          [_vm._v("Create a new dataset")]
        ),
        _vm._v(" "),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("strong", [_vm._v("or use existing one")]),
        _vm._v(" "),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _vm._l(_setup.datasets, function (d) {
          return _c(
            "button",
            {
              staticClass: "btn btn-primary",
              on: {
                click: function ($event) {
                  return _setup.handleAttachDatasetCommandV1(d.DatasetId)
                },
              },
            },
            [_vm._v(_vm._s(d.Name))]
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }